import styled from "styled-components";
import { borderRadius, rawColors, spacing } from "@magicbi/ui-library";
import type { RunCellStatus } from "./RunStrip.types";

/** Segment colours shared by RunStrip and RunHeatmap (strip uses the solid, heatmap the soft). */
export const RUN_SOLID: Record<RunCellStatus, string> = {
  ok: rawColors.accent.green500,
  partial: rawColors.accent.amber500,
  failed: rawColors.accent.red500,
  running: rawColors.primary[500],
  none: rawColors.structural[100],
};

export const Strip = styled.span`
  display: inline-flex;
  gap: ${spacing[0.5]};
  align-items: center;
`;

export const Segment = styled.span<{ $status: RunCellStatus }>`
  display: block;
  width: 1rem;
  height: 0.1875rem;
  border-radius: ${borderRadius.sm};
  background-color: ${({ $status }) => RUN_SOLID[$status]};
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1);
`;
